import { invariant } from '@/shared/utils/typeAssertions'
import { inject, provide, type InjectionKey, type Ref } from 'vue'

export type HubFileTableContext = {
  isSelected: (id: string) => boolean
  setSelected: (id: string, state: boolean) => void
  filterErrors: Ref<boolean>
}

export const hubFileTableContextToken = Symbol(
  'hubFileTableContext',
) as InjectionKey<HubFileTableContext>

export function useHubFileTableContext() {
  const injection = inject(hubFileTableContextToken)
  invariant(injection, 'Hub file table context not provided')
  return injection
}

export function provideHubFileTableContext(value: HubFileTableContext) {
  provide(hubFileTableContextToken, value)
}
